
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import {
		getUserProductRankList
	} from '@/api/statistic';
	import PageFooter from '@/components/page-footer.vue';

	@Component({
		name: 'product-rank',
		components: {
			PageFooter
		}
	})
	export default class ProductRank extends Vue {
		private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
		private shop:any = {}
		private id = +this.$route.query.id;
		private list: any = [];
		private pageNo = 1;
		private pageSize = 20;
		private total = 0;

		private mounted() {
			this.shop = this.$route.query
			this.getList();
		}

		private changeCurrent(e: any) {
			this.pageNo = e;
			this.getList();
		}

		private async getList() {
			try {
				const res: any = await getUserProductRankList({
					ProductId: this.id,
					Skip: (this.pageNo - 1) * this.pageSize,
					Take: this.pageSize
				})
				this.total = res.Result.Total;
				this.list = res.Result.Results;
			} catch (e) {
				console.log(e);
			}
		}
	}
